import React, { Component } from 'react'
import { Tabs } from 'antd-mobile'
import classnames from 'classnames'
import Product from './components/Product'
import { h5FirstGoodsInfo } from '@/apis/share.ts'
import ProductPageByCategoryId from './components/ProductPageByCategoryId'
import { StickyContainer, StickyWrapper } from '@/common/sticky'
import throttle from 'lodash/throttle'
import { emptyObject } from '@/constant'
import { BaseComponentItemPropsType } from '@/typings/types'
import styles from './index.module.less'

if (typeof window !== 'undefined') {
  require('@/utils/img-lazy-load')
}

const clickFlag = false

interface IProps extends BaseComponentItemPropsType<any> {}

class NewProductFlow extends Component<IProps> {
  static config = {
    name: 'poizon-newProductFlow',
  }

  scrollEvent: (...args: any[]) => void
  componentDidMount() {
    this.setOperationCover()

    console.log('.......props', this.props)
  }
  state = {
    page: 0,
  }
  componentWillUnmount() {
    // window.removeEventListener('scroll', this.scrollEvent, 90);
  }

  setOperationCover() {
    if (typeof window === 'undefined') return
    if (window.editorFlag !== 'edit') return

    const pageId = this.props?.pageId
    const { spuIds, spuIdType } = this.props?.propsConfig?.tabList?.[0]
    const body: any = {
      pageId,
      goodsType: spuIdType === 'SPUID' ? 0 : 1,
    }
    if (spuIdType === 'SPUID') {
      body.firstSpuId = +spuIds.split(',')[0]
    } else {
      body.firstItem = spuIds.split(',')[0].trim()
    }

    h5FirstGoodsInfo(body)
  }

  renderContent = (tab) => <div></div>
  handleTabChange = (tab: any, index: number) => {
    this.setState({
      page: index,
    })
    // document.querySelector(`._product_item_${index}_`).scrollIntoView();
    // clickFlag = true;
    // setTimeout(() => {
    //   clickFlag = false;
    // }, 1000);
  }
  initScrollEvent = () => {
    const _this = this
    let domList: any = document.querySelectorAll('.productViewBox')
    domList = Array.from(domList)
    this.scrollEvent = function () {
      if (clickFlag) {
        return
      }
      const res = domList.map((ele, index) => {
        return {
          top: ele.getBoundingClientRect().top,
          nextTop: domList[index + 1] ? domList[index + 1].getBoundingClientRect().top : 0,
        }
      })
      const index = res.findIndex(({ top, nextTop }) => top <= 60 && nextTop >= -10)
      if (index >= 0) {
        _this.setState({
          page: index,
        })
      }
    }
    window.addEventListener('scroll', throttle(this.scrollEvent, 100), false)
  }

  calcTabItemStyle = () => {
    const { propsConfig, globalConfig } = this.props
    if (!propsConfig || !globalConfig) {
      return emptyObject
    }
    const { style = {} } = globalConfig
    const {
      tabItemPaddingLeft,
      tabItemPaddingRight,
      tabItemPaddingBottom,
      tabItemContentBg,
    } = propsConfig
    return {
      paddingLeft: tabItemPaddingLeft,
      paddingRight: tabItemPaddingRight,
      paddingBottom: tabItemPaddingBottom,
      background: tabItemContentBg || style.background,
    }
  }

  getTabs = () => {
    const { propsConfig } = this.props
    if (!propsConfig) return []
    const { tabList = [], source = 0, categoryList = [] } = propsConfig
    const tabs =
      (source ? categoryList : tabList).map(({ name, categoryId }, index) => ({
        title: name,
        index,
        categoryId,
      })) || []
    return tabs
    // tabs
  }

  render() {
    const { propsConfig, pageId, globalConfig } = this.props
    const { page } = this.state
    if (propsConfig === null) {
      return ''
    }
    const {
      tabList = [],
      tabBgColor: tabBarBackgroundColor,
      tabTextColorActive: tabBarActiveTextColor,
      tabTextColor: tabBarInactiveTextColor,
      tabBgColorActive,
      tabCount = 3,
      tabItemTitleBg,
      source = 0,
      categoryList = [],
      tabItemContentBg,
      tabItemTitleLeftBg,
      tabItemTitleRightBg,
      titleBgImgType,
    } = propsConfig

    const background = tabItemContentBg || globalConfig?.style?.background

    return (
      <div
        className={classnames({
          [styles['poizon-new-production-flow']]: true,
          ['poizon-new-production-flow']: true,
          'poizon-new-production-flow-source-1': !!source,
        })}
      >
        <StickyContainer>
          <Tabs
            page={page}
            tabs={this.getTabs()}
            onChange={this.handleTabChange}
            tabBarBackgroundColor={tabBarBackgroundColor}
            tabBarActiveTextColor={tabBarActiveTextColor}
            tabBarInactiveTextColor={tabBarInactiveTextColor}
            tabBarUnderlineStyle={{ opacity: 0, display: 'none' }}
            renderTabBar={(props) => (
              <StickyWrapper>
                {({ style }) => {
                  return (
                    <div className="module-venue-tab-default-bar" style={{ ...style, zIndex: 1 }}>
                      <Tabs.DefaultTabBar {...props} page={tabCount} />
                    </div>
                  )
                }}
              </StickyWrapper>
            )}
          >
            {this.renderContent}
          </Tabs>
          <div style={this.calcTabItemStyle()} className={styles['product-view-box-wrapper']}>
            {(source ? categoryList : tabList || []).map(
              ({ spuIds, name, categoryId, spuIdType }, index) => {
                if (index !== page) {
                  return null
                }
                return (
                  <div key={index} className={`_product_item_${index}_ productViewBox`}>
                    {source === 1 ? (
                      <ProductPageByCategoryId
                        // spuIds={spuIds}
                        groupName={name}
                        categoryId={categoryId}
                        editConfig={this.props.editConfig}
                        tabBarActiveTextColor={tabBarActiveTextColor}
                        tabItemTitleLeftBg={tabItemTitleLeftBg}
                        tabItemTitleRightBg={tabItemTitleRightBg}
                        globalConfig={globalConfig}
                        pageId={pageId}
                        tabItemTitleBg={tabItemTitleBg}
                        titleBgImgType={titleBgImgType}
                      />
                    ) : (
                      <Product
                        spuIds={spuIds}
                        spuIdType={spuIdType}
                        groupName={name}
                        editConfig={this.props.editConfig}
                        tabBarActiveTextColor={tabBarActiveTextColor}
                        globalConfig={globalConfig}
                        pageId={pageId}
                        tabItemTitleBg={tabItemTitleBg}
                        tabItemTitleLeftBg={tabItemTitleLeftBg}
                        tabItemTitleRightBg={tabItemTitleRightBg}
                        titleBgImgType={titleBgImgType}
                      />
                    )}
                  </div>
                )
              }
            )}
          </div>
        </StickyContainer>
        <style>
          {`
            .am-tabs-default-bar-tab-active {
              background: ${tabBgColorActive || 'rgb(43, 43, 43)'} !important;
            }
            .poizon-new-production-flow .module-venue-tab-default-bar .am-tabs-default-bar-tab::after {
              background-color: ${background} !important;
            }
          `}
        </style>
      </div>
    )
  }
}

export default NewProductFlow
